import React, { useEffect } from "react";
import { BaseDocumentsLayout } from "features/BaseDocumentsLayout/BaseDocumentsLayout";
import { DocumentsOperations } from "constant-data/documentsData";
import { useParams } from "react-router";
import { useAtom } from "jotai/index";

import { DocumentsContainer } from "components/DocumentsContainer/DocumentsContainer";

import useDocuments from "../../hooks/useDocuments";
import {
  documentsFiltersAtom,
  documentsFiltersInit,
  selectedDocumentTypeAtom,
} from "../../atoms/documentsAtom";

export const DocumentPage = (): JSX.Element => {
  const { id: docOperationIdFromParams } = useParams();

  const { getDocuments, getAndSaveData, getAndSavePrintTemplates } =
    useDocuments();

  const [documentsFilters, setDocumentsFilters] = useAtom(documentsFiltersAtom);
  const [, setSelectedDocumentType] = useAtom(selectedDocumentTypeAtom);

  useEffect(() => {
    if (!documentsFilters.shouldUpdate) return;

    const timeout = setTimeout(() => {
      getDocuments().then();
    }, 300);

    return () => clearTimeout(timeout);
  }, [documentsFilters]);

  useEffect(() => {
    const documentOperation = DocumentsOperations.find(
      (i) => i.id === docOperationIdFromParams
    );

    if (documentOperation) {
      setSelectedDocumentType(documentOperation);
      setDocumentsFilters(documentsFiltersInit as any);
      setDocumentsFilters({ type: docOperationIdFromParams } as any);
      getAndSavePrintTemplates(docOperationIdFromParams).then();
    }
  }, [docOperationIdFromParams]);

  useEffect(() => {
    getAndSaveData().then();
  }, []);

  return (
    <DocumentsContainer>
      <BaseDocumentsLayout />
    </DocumentsContainer>
  );
};
